var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mx-2 elevation-0",attrs:{"color":"secondary","fab":""},on:{"click":_vm.openAppDownload}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"large":""}},[_vm._v("mdi-calendar-plus")])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v("Add to my calendar")])])}
var staticRenderFns = []

export { render, staticRenderFns }